// Public-safe website copy only. Do not add tax numbers, registry IDs, or private filing details here.

export const ORGANIZATION_NAME = 'Do Good Day Hub';
export const ORGANIZATION_SHORT = 'DGDH';
export const LOCATION = 'Cleveland Heights, Ohio';
export const CONTACT_EMAIL = 'hello@dogooddayhub.org';

export const TAGLINE = 'Community, purpose, and everyday opportunity.';
export const MISSION =
  'Do Good Day Hub creates community and meaningful opportunities for individuals with developmental disabilities through local vocational and volunteer outreach.';
export const MISSION_SHORT =
  'Local outreach that helps people connect, contribute, and build confidence through meaningful days.';

export const NAV_ITEMS = [
  { label: 'Mission', href: '#mission' },
  { label: 'Programs', href: '#programs' },
  { label: 'Pathway', href: '#pathway' },
  { label: 'Join In', href: '#join' },
  { label: 'Contact', href: '#contact' },
];

export const IMPACT_POINTS = [
  { label: 'Community-first', value: 'Local' },
  { label: 'Focus', value: 'Abilities' },
  { label: 'Outreach', value: 'Hands-on' },
];

export const PROGRAMS = [
  {
    title: 'Vocational Pathways',
    summary:
      'Supportive opportunities that help participants explore everyday work, service, and responsibility in welcoming local settings.',
  },
  {
    title: 'Volunteer Outreach',
    summary:
      'Community service moments shaped around kindness, consistency, and practical contribution.',
  },
  {
    title: 'Community Connection',
    summary:
      'Gatherings and partner relationships that make belonging visible and repeatable.',
  },
  {
    title: 'Family Support',
    summary:
      'Clear communication and inclusive activities that help families and caregivers stay connected to each step.',
  },
];

export const PATHWAY_STEPS = [
  {
    step: '01',
    title: 'Connect',
    body: 'Listen first, learn each person’s strengths, and identify local opportunities that feel welcoming.',
  },
  {
    step: '02',
    title: 'Participate',
    body: 'Create steady volunteer and vocational outreach experiences with caring community partners.',
  },
  {
    step: '03',
    title: 'Grow',
    body: 'Celebrate progress, deepen relationships, and keep building meaningful days together.',
  },
];

export const GET_INVOLVED = [
  {
    audience: 'Volunteers',
    body: 'Share time, encouragement, or hands-on support during outreach activities.',
    cta: 'Volunteer',
    subject: 'Volunteer Inquiry — Do Good Day Hub',
  },
  {
    audience: 'Community Partners',
    body: 'Open doors for local service, learning, and vocational exploration.',
    cta: 'Partner',
    subject: 'Partnership Inquiry — Do Good Day Hub',
  },
  {
    audience: 'Supporters',
    body: 'Help sustain inclusive programming, supplies, transportation, and community events.',
    cta: 'Support',
    subject: 'Support Inquiry — Do Good Day Hub',
  },
];
